export const PRPC_OW_VERSION = "2.0.0-alpha.23";
// Версия протокола: клиент и сервер сверяют её на init.
